import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../const';
import { setActivePage } from '../slice';

/**
 * Hook to sync the current route location with Redux state
 * This enables navigation back to the main view when clicking on nav items
 */
const useSyncActivePage = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Special handling for campaign routes - they should map to HOME
    if (location.pathname.startsWith('/campaign/')) {
      dispatch(setActivePage(ROUTES.HOME));
    } else {
      dispatch(setActivePage(location.pathname));
    }
  }, [location.pathname, dispatch]);
};

export default useSyncActivePage;
